import Api from '../Api';

import { url } from './config';
import { Passport } from './types';

class ExtendedApi extends Api<Passport> {}

const api = new ExtendedApi(url);

export default api;
